<template>
    <div class="strength">
        <img src="/images/background2.jpg" alt="" class="wow background">
        <div class="header">
            <div class="title">
                <div class="en">
                    <p>R & D</p>
                    <p>strength</p>
                </div>
                <div class="cn">研发实力</div>
            </div>
        </div>
        
        <div class="container flex flex-space-between flex-align-center flex-wrap">
            <div class="box">
                <div class="txt" v-html="art.content"></div>
                <div class="more">
                    <router-link :to="'/Research/'+art.tid">- 了解更多 -</router-link>
                </div>
            </div>
            <div class="link flex flex-space-between">
                <div class="item" @click="btnClick('btn1')" :class="{active: acbtn=='btn1'}">
                    <div class="icon">
                        <img src="/images/icon1.png" alt="">
                    </div>
                    <div class="tit">生产实力</div>
                </div>
                <div class="item" @click="btnClick('btn2')" :class="{active: acbtn=='btn2'}">
                    <div class="icon">
                        <img src="/images/icon2.png" alt="">
                    </div>
                    <div class="tit">科研中心</div>
                </div>
                <div class="item" @click="btnClick('btn3')" :class="{active: acbtn=='btn3'}">
                    <div class="icon">
                        <img src="/images/icon3.png" alt="">
                    </div>
                    <div class="tit">品质管理</div>
                </div>
                <div class="item" @click="btnClick('btn4')" :class="{active: acbtn=='btn4'}">
                    <div class="icon">
                        <img src="/images/icon4.png" alt="">
                    </div>
                    <div class="tit">设备仪器</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const arts = {
  btn1: {
    tid: 1,
    content: ''
  },
  btn2: {
    tid: 2,
    content: ''
  },
  btn3: {
    tid: 3,
    content: ''
  },
  btn4: {
    tid: 4,
    content: ''
  }
}
import { mapState } from 'vuex'
export default {
  data () {
    return {
      acbtn: 'btn1',
      art: arts['btn1'],
      typeID: {
        btn1: {
          en: '54',
          'zh-CN': '50'
        },
        btn2: {
          en: '55',
          'zh-CN': '51'
        },
        btn3: {
          en: '56',
          'zh-CN': '52'
        },
        btn4: {
          en: '57',
          'zh-CN': '53'
        }
      }
    }
  },
  computed: {
    ...mapState({
      lang: state => state.lang
    }),
    btn1id(){
      return this.typeID.btn1[this.lang]
    },
    btn2id(){
      return this.typeID.btn2[this.lang]
    },
    btn3id(){
      return this.typeID.btn3[this.lang]
    },
    btn4id(){
      return this.typeID.btn4[this.lang]
    }
  },
  watch: {
    lang: 'getdata'
  },
  methods: {
    btnClick (btn) {
      this.acbtn = btn
      this.art = arts[btn]
    },
    getdata(){
      let url1 = `/php/singlepage.php?id=${this.btn1id}`
      this.$$axios.get(url1).then(res => {
        arts.btn1.content = res.data.CONTENT
      })
      let url2 = `/php/singlepage.php?id=${this.btn2id}`
      this.$$axios.get(url2).then(res => {
        arts.btn2.content = res.data.CONTENT
      })
      let url3 = `/php/singlepage.php?id=${this.btn3id}`
      this.$$axios.get(url3).then(res => {
        arts.btn3.content = res.data.CONTENT
      })
      let url4 = `/php/singlepage.php?id=${this.btn4id}`
      this.$$axios.get(url4).then(res => {
        arts.btn4.content = res.data.CONTENT
      })
    }
  },
  mounted(){
    this.getdata()
  }
}
</script>

<style scoped>
.strength{
    /* background: url(/images/background2.jpg)no-repeat center / cover; */
    position: relative;
    overflow: hidden;
}
.strength img.background{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: 3s;
    z-index: -1;
    animation: scale 6s forwards;
    transform: scale(1.1);
    visibility: visible !important;
}
@keyframes scale{
    from{
        transform: scale(1.1);
    }to{
        transform: scale(1);
    }
}
.strength .header{
    max-width: 1500px;
    padding-top: 60px;
    margin: 0 auto;
}
.strength .title{
    color: #212121;
    border-bottom: 1px solid rgba(198,198,198,0.5);
    padding: 20px 0;
    text-align: center;
    max-width: 615px;
    margin: 0 auto;

}
.strength .title .en{
    font-size: 40px;
    text-transform: uppercase;
    font-family: 'CANARO BOLD';
}
.strength .title .cn{
    font-size: 35px;
}
.strength .container{
    width: 1500px;
    max-width: 100%;
    margin: 0 auto;
    padding: 150px 0;

}
.strength .container .box{
    width: 43.5%;
    margin-right: 6.5%;
    background-color:rgba(255,255,255,.3);
    padding: 4%; 
}
.strength .container .box .txt{
    font-size: 14px;
    color: #000;
    line-height: 35px;
    min-height: 175px;
}
.strength .container .box .more{
    text-align: right;
    margin-top: 30px;
}
.strength .container .box .more a{
    font-size: 12px;
    color: #004b94;
    position: relative;
}
.strength .container .box .more a::before{
    content: "";
    position: absolute;
    bottom: 0;
    left: 50%;
    width: 0;
    height: 1px;
    background: #004b94;
    transform: translateX(-50%);
    transition: .3s;
}
.strength .container .box .more a:hover::before{
    width: 100%;
}
.strength .container .link{
    width: 50%;
}
.strength .container .link .item{
    text-align: center;
    cursor: pointer;
}
.strength .container .link .item .icon{
    background: url(/images/border.png)no-repeat center;
    width: 74px;
    height: 85px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: .3s;
}
.strength .container .link .item:hover .icon,.strength .container .link .item.active .icon{
    background-image: url(/images/border_h.png);
}
.strength .container .link .item .tit{
    font-size: 16px;
    color: #000;
    margin-top: 10px;
}
@media (max-width: 768px){
  .strength .title .en{
    font-size: 24px;
  }
  .strength .title .cn{
    font-size: 20px;
  }
  .strength .container{
    padding: 50px 0;
  }
  .strength .container .box{
    width: 100%;
    margin-right: 0;
  }
  .strength .container .link{
    width: 100%;
    padding: 20px;
  }
}
</style>


